var _path, _path2, _path3, _g, _rect, _g2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "#FDDFCA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2227_60402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 27,
    width: 34,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 71.2668V28.3524C38.0363 27.9844 38.6341 27.8596 39.4303 27.9844C39.9075 28.0592 40.4824 28.1808 41.1521 28.3524C42.7244 28.7578 48.8841 26.8149 52.5835 29.4439C57.148 32.6872 45.1273 41.4098 48.5277 54.4079C49.6631 58.7396 62.2155 60.8165 65.3658 63.1243C72.2068 68.1389 71.2238 70.3063 70.1516 71.2668C68.5851 72.667 42.6755 70.7086 42.1524 71.2668C41.727 71.719 41.5315 71.2107 40.7755 71.2668C40.6606 71.2762 40.2122 71.2762 39.4303 71.2668H37.6367Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2227_60402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2227_60402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: -20,
    width: 116,
    height: 126
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.162 -19.3594H10.1875V105.383H125.162V-19.3594Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2227_60402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3541 26.3799H36.2031V73.3422H72.3541V26.3799Z",
    fill: "#FDE0CC"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2227_60402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 33,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 33,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2227_60402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6213 54.0259C61.6213 52.5166 61.7952 51.361 62.143 50.5592C62.4908 49.7575 63.2169 48.8686 64.3213 47.8926C65.1811 47.1268 65.8328 46.4324 66.2763 45.8092C66.7199 45.1861 66.9417 44.4797 66.9417 43.6899C66.9417 42.6421 66.5849 41.7712 65.8713 41.0772C65.1576 40.3832 64.175 40.0362 62.9237 40.0362C61.7819 40.0362 60.893 40.3421 60.257 40.9539C59.6212 41.5659 59.1383 42.2489 58.8083 43.0029L56.375 41.9336C56.893 40.6567 57.7016 39.5921 58.8007 38.7399C59.8998 37.8879 61.2741 37.4619 62.9237 37.4619C65.0774 37.4619 66.7351 38.0691 67.8967 39.2836C69.0582 40.498 69.639 41.9395 69.639 43.6079C69.639 44.6506 69.413 45.5707 68.961 46.3682C68.5088 47.1656 67.8229 47.9959 66.9033 48.8592C65.746 49.9208 65.0293 50.7579 64.7533 51.3706C64.4771 51.9835 64.339 52.8686 64.339 54.0259H61.6213ZM62.9237 61.6669C62.3783 61.6669 61.9087 61.4699 61.5147 61.0759C61.1207 60.6819 60.9237 60.2122 60.9237 59.6669C60.9237 59.1216 61.1207 58.6519 61.5147 58.2579C61.9087 57.8639 62.3783 57.6669 62.9237 57.6669C63.469 57.6669 63.9387 57.8639 64.3327 58.2579C64.7267 58.6519 64.9237 59.1216 64.9237 59.6669C64.9237 60.2122 64.7267 60.6819 64.3327 61.0759C63.9387 61.4699 63.469 61.6669 62.9237 61.6669Z",
    fill: "#FF6B00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8844 74.2329C41.2955 74.2329 39.9816 73.7135 38.9427 72.6746C37.9038 71.6357 37.3844 70.3218 37.3844 68.7329V30.5996C37.3844 29.0107 37.9038 27.6968 38.9427 26.6579C39.9816 25.6191 41.2955 25.0996 42.8844 25.0996H81.0177C82.6066 25.0996 83.9205 25.6191 84.9594 26.6579C85.9983 27.6968 86.5177 29.0107 86.5177 30.5996V68.7329C86.5177 70.3218 85.9983 71.6357 84.9594 72.6746C83.9205 73.7135 82.6066 74.2329 81.0177 74.2329H42.8844ZM42.8844 71.6663H81.0177C81.751 71.6663 82.4233 71.3607 83.0344 70.7496C83.6455 70.1385 83.951 69.4663 83.951 68.7329V30.5996C83.951 29.8663 83.6455 29.1941 83.0344 28.5829C82.4233 27.9718 81.751 27.6663 81.0177 27.6663H42.8844C42.151 27.6663 41.4788 27.9718 40.8677 28.5829C40.2566 29.1941 39.951 29.8663 39.951 30.5996V68.7329C39.951 69.4663 40.2566 70.1385 40.8677 70.7496C41.4788 71.3607 42.151 71.6663 42.8844 71.6663ZM32.9844 84.1329C31.3955 84.1329 30.0816 83.6135 29.0427 82.5746C28.0038 81.5357 27.4844 80.2218 27.4844 78.6329V37.9329H30.051V78.6329C30.051 79.3663 30.3566 80.0385 30.9677 80.6496C31.5788 81.2607 32.251 81.5663 32.9844 81.5663H73.6844V84.1329H32.9844Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLogo);
export default __webpack_public_path__ + "static/media/faq_logo.bd2e42db54e6f82122f11d7b199767ca.svg";
export { ForwardRef as ReactComponent };